export default __webpack_public_path__ + "static/media/questionIcon.89f698fb.svg";